import gql from 'graphql-tag'

export const eventCodeUpdate = gql`
  mutation eventCodeUpdate($data: EventCodeUpdateInput!) {
    eventCodeUpdate(input: $data) {
      success
    }
  }
`
